import { Directive } from '@angular/core';
import { FlexOrderDirective as FlexLayoutFlexOrderDirective } from '@angular/flex-layout';

const inputs = [
  'flLayoutFlexOrder',
  'flLayoutFlexOrder.mobile',
  'flLayoutFlexOrder.tablet',
  'flLayoutFlexOrder.desktop-small',
  'flLayoutFlexOrder.desktop-large',
  'flLayoutFlexOrder.desktop-xlarge',
  'flLayoutFlexOrder.desktop-xxlarge',
];

@Directive({
  selector: `
    [flLayoutFlexOrder],
    [flLayoutFlexOrder.mobile],
    [flLayoutFlexOrder.tablet],
    [flLayoutFlexOrder.desktop-small],
    [flLayoutFlexOrder.desktop-large],
    [flLayoutFlexOrder.desktop-xlarge],
    [flLayoutFlexOrder.desktop-xxlarge],
  `,
  inputs,
})
export class FlexOrderDirective extends FlexLayoutFlexOrderDirective {
  protected inputs = inputs;
}
